module.exports = __webpack_public_path__ + "img/logo.9341b19e.png";